import { render, staticRenderFns } from "./PlatformCard.vue?vue&type=template&id=aa99d112&scoped=true"
import script from "./PlatformCard.vue?vue&type=script&lang=js"
export * from "./PlatformCard.vue?vue&type=script&lang=js"
import style0 from "./PlatformCard.vue?vue&type=style&index=0&id=aa99d112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa99d112",
  null
  
)

export default component.exports